import CardLayout from '../../../common/CardLayout';
import AvisoManutencao from '../AvisoManutencao';

export default function StatusCondensadores({
	condensadores,
	alarmes
}) {

	return (
		<CardLayout>
			<div>
				<h2 className="text-lg 2xl:text-2xl font-semibold text-accent drop-shadow-1xl text-center mb-1.5">
					Status dos Condensadores
				</h2>
				<div className='flex flex-wrap w-full gap-1'>
					{condensadores.map((condensador) => {
						const tudoDesligado = alarmes.some(
							a => a.tipoAlarme === 'COND_EQUIPAMENTOS' && a.equipamentoId === condensador.id
						);
						const ventAlarmes = alarmes.filter(
							a => a.equipamentoIdRelacionado === condensador.id && a.tipoEquipamento === 'Ventilador'
						).length;
						const bombaAlarmes = alarmes.filter(
							a => a.equipamentoIdRelacionado === condensador.id && a.tipoEquipamento === 'Bomba'
						).length;

						return (
							<div
								key={condensador.id}
								className={"flex w-full flex-1 gap-x-1 rounded-md border-[1px] border-gray-700 " + (tudoDesligado && "animate-warning")}
							>
								{/* Nome do condensador */}
								<div className="flex flex-col justify-center items-center bg-accent/20 rounded-bl-md rounded-tl-md py-[1px] px-[5px]">
									<h2 className="text-lg 2xl:text-2xl font-semibold text-accent drop-shadow-1xl min-w-20 text-center w-full whitespace-nowrap">
										{condensador.nome}
										<AvisoManutencao tipo="Condensador" nome={condensador.nome} />
									</h2>
								</div>
								{/* divider */}
								<div className="w-px h-full bg-gray-700 -ml-1"></div>

								{/* Ventiladores */}
								<div className="flex flex-col flex-1 justify-center items-center px-2 py-1 gap-[2px]">
									<span className="text-xs text-secondary uppercase tracking-wide">Ventiladores</span>
									{tudoDesligado ? (
										<span className="text-alarm font-semibold">OFF</span>
									) : ventAlarmes > 0 ? (
										<span className="text-alarm flex justify-center items-center text-[16px]">
											<span className="animate-ping inline-block h-3 w-3 rounded-full ring-2 ring-alarm/40 bg-alarm mx-2"></span>
											({ventAlarmes})
										</span>
									) : (
										<span className="text-secondary">-</span>
									)}
								</div>
								{/* divider */}
								<div className="w-px h-full bg-gray-700"></div>

								{/* Bombas */}
								<div className="flex flex-col flex-1 justify-center items-center px-2 py-1 gap-[2px]">
									<span className="text-xs text-secondary uppercase tracking-wide">Bombas</span>
									{tudoDesligado ? (
										<span className="text-alarm font-semibold">OFF</span>
									) : bombaAlarmes > 0 ? (
										<span className="text-alarm flex justify-center items-center text-[16px]">
											<span className="animate-ping inline-block h-3 w-3 rounded-full ring-2 ring-alarm/40 bg-alarm mx-2"></span>
											({bombaAlarmes})
										</span>
									) : (
										<span className="text-secondary">-</span>
									)}
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</CardLayout>
	);
}
